
































































import CompanyProfileDto from '@/models/Companies/CompanyProfileDto'
import { Component, Vue } from 'vue-property-decorator'
import { CompanyListModule } from '@/store/modules/companyList';
import PageNames from '@/router/PageNames';
import GeoPoint from '@/models/Shared/GeoPoint';
import PrepareForLaunch from '@/components/Shared/PrepareForLaunch.vue';
import GiganautVue from '@/components/Shared/GiganautVue';
import CompanyCreate from '@/components/Companies/CompanyCreate.vue';
import Alert from '@/components/Shared/Alert.vue';

@Component({
  name: 'CompanyList',
  components: {
    CompanyCreate, PrepareForLaunch, Alert
  }
})
export default class extends GiganautVue {

  center: GeoPoint = {lng: 0, lat: 0};

  async navigateToCompany(item: CompanyProfileDto) {
    const companyId = item.id;
    this.$router.push({ name: PageNames.AgencyCompanyDetails, params: { companyid: companyId } });
  }

  get companies(): CompanyProfileDto[] {
    return CompanyListModule.companies;
  }

  async centerMap(geo: GeoPoint) {
    this.center = geo;
  }

  get loading() {
    return CompanyListModule.loading;
  }

  created() {
    this.getCompanies();
  }

  private getCompanies() {
    CompanyListModule.searchCompanies();
  }
 
  private search = '';
  
  private headers = [
    // { text: '', value: 'avatar' },
    { text: 'Ref', value: 'sequenceNumber'},
    { text: 'Brand Name', value: 'brandName' },
    { text: 'Email Address', value: 'emailAddress' },
    { text: 'PhoneNumber', value: 'phoneNumber' },
    { text: 'Website', values: 'website' },
    { text: 'Actions' },
  ]
}
